// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1_ky6","filesListContainer":"PosDisputesFiles_filesListContainer__3siRU","filesButton":"PosDisputesFiles_filesButton__3W5zl"};